var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { useVModel } from "../node_modules/.pnpm/@vueuse_core@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/core/index.js";
import { ref, watch, computed } from "vue";
function useBetterVModel({
  props,
  realProps,
  key,
  emits,
  defaultValue
}) {
  const hasProp = Object.prototype.hasOwnProperty.call(realProps, key), inner = useVModel(props, key, emits, {
    passive: !1,
    defaultValue
  }), local = ref(inner.value ?? defaultValue);
  return watch(() => props[key], (v) => {
    hasProp && (local.value = v);
  }), computed({
    get: /* @__PURE__ */ __name(() => hasProp ? inner.value : local.value, "get"),
    set: /* @__PURE__ */ __name((v) => {
      hasProp ? inner.value = v : (local.value = v, emits == null || emits(`update:${String(key)}`, v));
    }, "set")
  });
}
__name(useBetterVModel, "useBetterVModel");
export {
  useBetterVModel
};
//# sourceMappingURL=useBetterVModel.js.map
